import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import axios from "axios";
import Calculation from "./Calculation";
import { baseUrl } from "./../../Apiurls/Apiurls";
import { useContext } from "react";
import { AuthContext } from "./../../Contextapi/ContextApi";
import Navbar from "../../Shared/Navbar";
import "./AddAnalysis.css";

const AddAnalysis = () => {
   const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const { id } = useParams();

  const [analysis, setAnalysis] = useState({
    noticePeriod: "",
    assessment: "",
    fmcgSalesExp: "",
    pedigree: "",
    shortlist: "",
    source: "Select",
    sharedOn: "",
    consultant: "",
    payroll: "",
    tradeHandled: "",
    businessVolume: "",
    geographyCovered: "",
    nativePlace: "",
    distributorsHandled: "",
    productsHandled: "",
    accountsRetailCounters: "",
    teamSize: "",
    reportingTo: "",
    monthlyTurnover: "",
    reasonForChange: "",
    languagesKnown: "",
    itLanguagesKnown: "",
    databasesKnown: "",
    softwareKnown: "",
    additionalSkills: "",
    linkedinProfile: "",
    comments: "",
    isNoticePeriodNegotiable: "",
  });
  const [formData, setFormData] = useState({
    noticePeriod: "",
    assessment: "",
    fmcgSalesExp: "",
    pedigree: "",
    shortlist: "",
    source: "Select",
    sharedOn: "",
    consultant: "",
    payroll: "",
    tradeHandled: "",
    businessVolume: "",
    geographyCovered: "",
    nativePlace: "",
    distributorsHandled: "",
    productsHandled: "",
    accountsRetailCounters: "",
    teamSize: "",
    reportingTo: "",
    monthlyTurnover: "",
    reasonForChange: "",
    languagesKnown: "",
    itLanguagesKnown: "",
    databasesKnown: "",
    softwareKnown: "",
    additionalSkills: "",
    linkedinProfile: "",
    comments: "",
    isNoticePeriodNegotiable: "",
  });

  const [editField, setEditField] = useState(null);
  const [calculationData, setCalculationData] = useState({
    currentTotalCTC: 0,
    currentFixedCTC: 0,
    ctcIncreasePercentage: 0,
    ctcType: "Select",
    calculatedCTC: 0,
  });

  const updateCalculationData = (data) => {
    setCalculationData(data);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCtcTypeChange = (e) => {
    const ctcType = e.target.value;
    setFormData({ ...formData, ctcType });
    calculateExpectedCTC(); // Call the calculation function when ctcType changes
  };

  const calculateExpectedCTC = () => {
    const { currentCTC, basicCTC, ctcIncreasePercentage, ctcType } = formData;
    let expectedCTC = 0;

    if (ctcType === "basicCtC") {
      expectedCTC = basicCTC + (ctcIncreasePercentage * basicCTC) / 100;
    } else if (ctcType === "currentCtC") {
      expectedCTC = currentCTC + (ctcIncreasePercentage * currentCTC) / 100;
    }

    setFormData({ ...formData, expectedCTC });
  };

  const handleLogout = () => {
    logout();
    alert("You have successfully logged out");
    navigate("/");
  };

  const enableEditMode = (fieldName) => {
    setEditField(fieldName);
  };

 
  


   useEffect(() => {
    
    const fetchAnalysisData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/tracker/${id}`);
        setAnalysis(res.data);
        setFormData(res.data);
      } catch (err) {
        console.error("Error fetching data:", err);
        alert("Error fetching data. Please check server.");
      }
    };

    fetchAnalysisData();
  }, [id]);

  // ...

  const handleChange = (e, fieldName) => {
    if (editField === fieldName) {
      const { value } = e.target;
      setFormData({ ...formData, [fieldName]: value });
    }
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

 

  const handleSubmit = async (e) => {
    e.preventDefault();

    
    const combinedData = {
      ...analysis, 
      ...formData,
      ...calculationData, 
    };
    try {
      await axios.put(`${baseUrl}/api/tracker/${id}`, combinedData);
      alert("Analysis data updated successfully!");
      navigate("/view");
    } catch (err) {
      console.error("Error updating analysis:", err);
      alert("Error updating analysis. Please check server.");
    }
  };

  if (!analysis) {
    return <div className="container">Loading...</div>;
  }

  const handleBackClick = () => {
    navigate("/view");
  };

  return (
    <div className="container-fluid mt-5 " >
      <div className="row ">
        <div className="col-md-2">
          <Navbar />
        </div>
        <div className="col-md-10">
          <h2 className="mb-4 text-center" style={{marginTop: "50px"}}>Add Analysis</h2>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Email:</label>
                    {editField === "email" ? (
                      <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={(e) => handleChange(e, "email")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("email")}>
                        <span className="form-control">{formData.email}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Name:</label>
                    {editField === "name" ? (
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={(e) => handleChange(e, "name")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("name")}>
                        <span className="form-control">{formData.name}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Age:</label>
                    {editField === "age" ? (
                      <input
                        type="text"
                        name="age"
                        value={formData.age}
                        onChange={(e) => handleChange(e, "age")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("age")}>
                        <span className="form-control">{formData.age}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Contact No:</label>
                    {editField === "contactNo" ? (
                      <input
                        type="text"
                        name="contactNo"
                        value={formData.contactNo}
                        onChange={(e) => handleChange(e, "contactNo")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("contactNo")}>
                        <span className="form-control">
                          {formData.contactNo}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Location:</label>
                    {editField === "location" ? (
                      <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={(e) => handleChange(e, "location")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("location")}>
                        <span className="form-control">
                          {formData.location}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Education Qualification:</label>
                    {editField === "educationQualification" ? (
                      <input
                        type="text"
                        name="educationQualification"
                        value={formData.educationQualification}
                        onChange={(e) =>
                          handleChange(e, "educationQualification")
                        }
                        className="form-control"
                      />
                    ) : (
                      <div
                        onClick={() => enableEditMode("educationQualification")}
                      >
                        <span className="form-control">
                          {formData.educationQualification}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Organisation:</label>
                    {editField === "organisation" ? (
                      <input
                        type="text"
                        name="organisation"
                        value={formData.organisation}
                        onChange={(e) => handleChange(e, "organisation")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("organisation")}>
                        <span className="form-control">
                          {formData.organisation}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Designation:</label>
                    {editField === "designation" ? (
                      <input
                        type="text"
                        name="designation"
                        value={formData.designation}
                        onChange={(e) => handleChange(e, "designation")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("designation")}>
                        <span className="form-control">
                          {formData.designation}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Gender:</label>
                    {editField === "gender" ? (
                      <input
                        type="text"
                        name="gender"
                        value={formData.gender}
                        onChange={(e) => handleChange(e, "gender")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("gender")}>
                        <span className="form-control">{formData.gender}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Total Experience:</label>
                    {editField === "totalExperience" ? (
                      <input
                        type="text"
                        name="totalExperience"
                        value={formData.totalExperience}
                        onChange={(e) => handleChange(e, "totalExperience")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("totalExperience")}>
                        <span className="form-control">
                          {formData.totalExperience}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Positions Suitable For:</label>
                    {editField === "positionsSuitableFor" ? (
                      <input
                        type="text"
                        name="positionsSuitableFor"
                        value={formData.positionsSuitableFor}
                        onChange={(e) =>
                          handleChange(e, "positionsSuitableFor")
                        }
                        className="form-control"
                      />
                    ) : (
                      <div
                        onClick={() => enableEditMode("positionsSuitableFor")}
                      >
                        <span className="form-control">
                          {formData.positionsSuitableFor}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Skills:</label>
                    {editField === "skills" ? (
                      <input
                        type="text"
                        name="skills"
                        value={formData.skills}
                        onChange={(e) => handleChange(e, "skills")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("skills")}>
                        <span className="form-control">{formData.skills}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Resume:</label>
                    {editField === "resumeUrl" ? (
                      <input
                        type="text"
                        name="resumeUrl"
                        value={formData.resumeUrl}
                        onChange={(e) => handleChange(e, "skills")}
                        className="form-control"
                      />
                    ) : (
                      <div onClick={() => enableEditMode("resumeUrl")}>
                        <span className="form-control">{formData.resumeUrl}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="fmcgSalesExp">FMCG / Sales Exp:</label>
                      <input
                        type="text"
                        id="fmcgSalesExp"
                        name="fmcgSalesExp"
                        value={formData.fmcgSalesExp}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="pedigree">Pedigree:</label>
                      <textarea
                        type="text"
                        id="pedigree"
                        name="pedigree"
                        value={formData.pedigree}
                        onChange={handleInputChange}
                        className="form-control"
                        row="3"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="payroll">Payroll :</label>
                      <select
                        id="payroll"
                        name="payroll"
                        value={formData.payroll}
                        onChange={handleInputChange}
                        className="form-select"
                      >
                        <option value="Select">Select</option>
                        <option value="Onroll">Onroll</option>
                        <option value="Offroll">Offroll</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="tradeHandled">
                        Trade being handled :
                      </label>
                      <input
                        type="text"
                        id="tradeHandled"
                        name="tradeHandled"
                        value={formData.tradeHandled}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="businessVolume">Business Volume:</label>
                      <input
                        type="text"
                        id="businessVolume"
                        name="businessVolume"
                        value={formData.businessVolume}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="geographyCovered">
                        Geography being Covered:
                      </label>
                      <input
                        type="text"
                        id="geographyCovered"
                        name="geographyCovered"
                        value={formData.geographyCovered}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="nativePlace">
                        Candidate’s Native Place:
                      </label>
                      <input
                        type="text"
                        id="nativePlace"
                        name="nativePlace"
                        value={formData.nativePlace}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="distributorsHandled">
                        No. of Distributors being handled:
                      </label>
                      <input
                        type="text"
                        id="distributorsHandled"
                        name="distributorsHandled"
                        value={formData.distributorsHandled}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="productsHandled">
                        Products handled in the present company:
                      </label>
                      <input
                        type="text"
                        id="productsHandled"
                        name="productsHandled"
                        value={formData.productsHandled}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="accountsRetailCounters">
                        No. of Accounts/ Retail Counters:
                      </label>
                      <input
                        type="text"
                        id="accountsRetailCounters"
                        name="accountsRetailCounters"
                        value={formData.accountsRetailCounters}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="teamSize">
                        Team Size (Onroll / Offroll):
                      </label>
                      <input
                        type="text"
                        id="teamSize"
                        name="teamSize"
                        value={formData.teamSize}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportingTo">Reporting to:</label>
                      <input
                        type="text"
                        id="reportingTo"
                        name="reportingTo"
                        value={formData.reportingTo}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="monthlyTurnover">
                        Monthly Business Turn Over:
                      </label>
                      <input
                        type="text"
                        id="monthlyTurnover"
                        name="monthlyTurnover"
                        value={formData.monthlyTurnover}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <Calculation
                    calculationData={calculationData}
                    onCalculationChange={updateCalculationData}
                  />
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reasonForChange">
                        Reason For Change:
                      </label>
                      <input
                        type="text"
                        id="reasonForChange"
                        name="reasonForChange"
                        value={formData.reasonForChange}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="noticePeriod">Notice Period:</label>
                      <select
                        id="noticePeriod"
                        name="noticePeriod"
                        value={formData.noticePeriod}
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value="Select">Select</option>
                        <option value="Immediate">Immediate</option>
                        <option value="15 days">15 days</option>
                        <option value="30 days">30 days</option>
                        <option value="45 days">45 days</option>
                        <option value="2 months">2 months</option>
                        <option value="3 months">3 months</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="isNoticePeriodNegotiable">
                        Is Notice Period Negotiable:
                      </label>
                      <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "10px" }}>
                          <input
                            type="radio"
                            id="noticeNegotiableYes"
                            name="isNoticePeriodNegotiable"
                            value="Yes"
                            checked={
                              formData.isNoticePeriodNegotiable === "Yes"
                            }
                            onChange={handleRadioChange}
                          />
                          <label htmlFor="noticeNegotiableYes">Yes</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="noticeNegotiableNo"
                            name="isNoticePeriodNegotiable"
                            value="No"
                            checked={formData.isNoticePeriodNegotiable === "No"}
                            onChange={handleRadioChange}
                          />
                          <label htmlFor="noticeNegotiableNo">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="languagesKnown">Languages known:</label>
                      <input
                        type="text"
                        id="languagesKnown"
                        name="languagesKnown"
                        value={formData.languagesKnown}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="itLanguagesKnown">
                        IT Languages known:
                      </label>
                      <input
                        type="text"
                        id="itLanguagesKnown"
                        name="itLanguagesKnown"
                        value={formData.itLanguagesKnown}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="databasesKnown">Databases known:</label>
                      <input
                        type="text"
                        id="databasesKnown"
                        name="databasesKnown"
                        value={formData.databasesKnown}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="softwareKnown">Software known:</label>
                      <input
                        type="text"
                        id="softwareKnown"
                        name="softwareKnown"
                        value={formData.softwareKnown}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="additionalSkills">
                        Additional Skills:
                      </label>
                      <input
                        type="text"
                        id="additionalSkills"
                        name="additionalSkills"
                        value={formData.additionalSkills}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="linkedinProfile">LinkedIn profile:</label>
                      <input
                        type="text"
                        id="linkedinProfile"
                        name="linkedinProfile"
                        value={formData.linkedinProfile}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="comments">Comments:</label>
                      <textarea
                        id="comments"
                        name="comments"
                        value={formData.comments}
                        onChange={handleInputChange}
                        className="form-control"
                        rows="2" // You can adjust the number of rows as needed
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="shortlist">Shortlist:</label>
                      <input
                        type="text"
                        id="shortlist"
                        name="shortlist"
                        value={formData.shortlist}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="source">Source:</label>
                      <select
                        id="source"
                        name="source"
                        value={formData.source}
                        onChange={handleInputChange}
                        className="form-select"
                      >
                        <option value="Select">Select</option>
                        <option value="Refer">Refer</option>
                        <option value="Linkedin">Linkedin</option>
                        <option value="Social Media">Social Media</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="sharedOn">Shared On:</label>
                      <input
                        type="text"
                        id="sharedOn"
                        name="sharedOn"
                        value={formData.sharedOn}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="consultant">Consultant:</label>
                      <input
                        type="text"
                        id="consultant"
                        name="consultant"
                        value={formData.consultant}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="assessment">Assessment:</label>
                    <input
                      type="text"
                      id="assessment"
                      name="assessment"
                      value={formData.assessment}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                  </div>
                </div>
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                  
                  <button
                    className="btn btn-secondary "
                    style={{ marginLeft: "20px" }}
                    onClick={handleBackClick}
                  >
                    Back
                  </button>
                
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAnalysis;
